module.exports = __webpack_public_path__ + "media/Video 36b.b3ed1d28.mp4";